import { TableCard } from '../../../../components'
import { ListFiltersProvider } from '../core/ListFiltersProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { TermosListHeader } from './components/header/TermosListHeader'
import { TermosTable } from './table/TermosTable'

const TermosList = () => {
  return (
    <TableCard>
      <TermosListHeader />
      <TermosTable />
    </TableCard>
  )
}

export const TermosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <TermosList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
